"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@headlessui/react";
import { QuestionMarkCircleIcon, XMarkIcon } from "@heroicons/react/16/solid";
import { Fragment, useState } from "react";
import { TextMono } from "./ui/text";
import { Heading } from "./ui/heading";
const shortcutCategories = [{
  title: "Platform",
  items: [{
    name: "iOS",
    shortcuts: ["1"]
  }, {
    name: "Android",
    shortcuts: ["2"]
  }, {
    name: "Web",
    shortcuts: ["3"]
  }]
}, {
  title: "Theme",
  items: [{
    name: "Dark mode",
    shortcuts: ["D"]
  }, {
    name: "Light mode",
    shortcuts: ["L"]
  }]
}, {
  title: "Color Picker",
  items: [{
    name: "Primary color",
    shortcuts: ["P"]
  }, {
    name: "Secondary color",
    shortcuts: ["S"]
  }, {
    name: "Accent color",
    shortcuts: ["A"]
  }, {
    name: "Muted color",
    shortcuts: ["M"]
  }]
}, {
  title: "Preview",
  items: [{
    name: "Preview 1",
    shortcuts: ["Shift + 1"]
  }, {
    name: "Preview 2",
    shortcuts: ["Shift + 2"]
  }, {
    name: "Preview 3",
    shortcuts: ["Shift + 3"]
  }]
}];
export const ShortcutsDialog = () => {
  const $ = _c(9);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TextMono size="xs" className="group-data-hover:text-foreground flex items-center gap-1.5"><span className="hidden md:block">Keyboard </span>shortcuts</TextMono>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button type="button" className="group text-muted-foreground/70 data-hover:text-foreground flex items-center justify-center gap-1" onClick={t0}>{t1}{" "}<QuestionMarkCircleIcon className="size-3 -translate-y-px opacity-50" /></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogTitle className="mb-4 text-xl font-semibold">Keyboard shortcuts</DialogTitle>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="grid grid-cols-2 gap-6">{shortcutCategories.map(_temp2)}</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button onClick={t5} className="data-hover:bg-muted group hover:bg-border/35 data-checked:bg-border/50 absolute top-2 right-2 rounded-md p-2 focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 data-focus:outline-none" aria-label="Close"><XMarkIcon className="text-muted-foreground group-data-hover:text-foreground size-4" /></Button>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isOpen) {
    t7 = <>{t2}<Dialog open={isOpen} onClose={setIsOpen}>{t3}{t4}{t6}</Dialog></>;
    $[7] = isOpen;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
function _temp(item) {
  return <div key={item.name} className="flex items-center justify-between"><span className="text-sm">{item.name}</span><div className="flex items-center gap-2">{item.shortcuts.map((shortcut, index) => <Fragment key={`${item.name}-${shortcut}`}><kbd className="bg-muted rounded px-2 py-1 text-xs">{shortcut}</kbd>{index < item.shortcuts.length - 1 && <span>or</span>}</Fragment>)}</div></div>;
}
function _temp2(category) {
  return <div key={category.title}><Heading level={3} className="mb-3">{category.title}</Heading><div className="space-y-3.5">{category.items.map(_temp)}</div></div>;
}